<!-- side-bar single product slider start -->
<div class="theme-card">
    <h5 class="title-border">{{ title }}</h5>
    <owl-carousel-o [options]="NewProductSliderConfig" class="offer-slider">
        <ng-container *ngFor="let product of products | slice:0:3 ">  
            <ng-template carouselSlide>
                <div>
                  <div class="d-flex align-items-center" *ngFor="let product of products | slice:0:3 ">
                    <a [routerLink]="['/shop/product/left/sidebar', product.title.replace(' ', '-'), product.sku]"
                      class="d-flex align-items-center text-decoration-none w-100">
                      
                      <img class="img-fluid w-auto"
                          [defaultImage]="'assets/images/product/placeholder.jpg'" 
                          [lazyLoad]="product.images[0]" alt="">

                      <div class="media-body align-self-center ps-2">
                        <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
                        <h6 style="color: black !important; font-weight: bold !important; font-size: 20px;">
                          {{ product.title | titlecase }}
                        </h6>
                        <h4 style="color: #176ec0;">
                          {{ product.priceDiscount | currency:productService.Currency?.currency:'symbol' }}
                          <!-- <del *ngIf="product?.tienePromocion">
                            <span class="money"> 
                              {{ product?.price * productService.Currency?.price | currency:productService.Currency?.currency:'symbol' }}
                            </span>
                          </del> -->
                        </h4>
                        <div class="pt-2 text-center" *ngIf="product.envioGratis === true">
                          <span class="delivery-txt-blof" style="background-color: #ff7d0f !important;">Envío Gratis</span>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div>
                  <div class="d-flex align-items-center" *ngFor="let product of products | slice:3:6 ">
                    <a [routerLink]="['/shop/product/left/sidebar', product.title.replace(' ', '-'), product.sku]"
                      class="d-flex align-items-center text-decoration-none w-100">

                      <img class="img-fluid w-auto" 
                          [defaultImage]="'assets/images/product/placeholder.jpg'" 
                          [lazyLoad]="product.images[0]" alt="">

                      <div class="media-body align-self-center ps-2">
                        <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
                        <h6>{{ product.title | titlecase }}</h6>
                        <h4>
                          {{ product?.priceDiscount | currency:productService.Currency?.currency:'symbol' }}
                          <del *ngIf="product?.discount > 0">
                            <span class="money"> 
                              {{ product?.price * productService.Currency?.price | currency:productService.Currency?.currency:'symbol' }}
                            </span>
                          </del>
                        </h4>
                      </div>
                    </a>
                  </div>
                </div>
            </ng-template>
        </ng-container>
    </owl-carousel-o>
</div>
<!-- side-bar single product slider end -->
  